import { render } from "./MainContacts.vue?vue&type=template&id=55790772&scoped=true"
import script from "./MainContacts.vue?vue&type=script&lang=js"
export * from "./MainContacts.vue?vue&type=script&lang=js"

import "./MainContacts.vue?vue&type=style&index=0&id=55790772&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55790772"]])

export default __exports__